export default {"src":"/_next/static/media/filecheck.07e97d2b.svg","height":17,"width":14,"blurWidth":0,"blurHeight":0};